import React from "react";
import styled, { css } from "styled-components";

const VerticalGutterWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green3};
  margin: 0;
  width: 60px;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;

const VerticalHalfPill = styled.div`
  background-color: ${({ theme }) => theme.colors.green5};
  margin: auto;
  width: 23px;
  height: 100%;
  border-radius: 20px;
  margin: 0;
  ${({ theme }) => theme.media.desktopUp`
    width: 20px;
  `};
  ${props =>
    props.left &&
    css`
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    `}
  ${props =>
    props.right &&
    css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `}
  ${props =>
    props.upper &&
    css`
      ${props.theme.media.desktopDown`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
    `}
  ${props =>
    props.lower &&
    css`
      ${props.theme.media.desktopDown`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      `}
    `}
`;

const HorizontalGutterWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green3};
  margin: 0;
  margin-top: ${props => props.marginTop};
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${props => props.mobileWidth};
  ${props => props.theme.media.desktopUp`
    width: ${props => props.width};
  `};
`;

const HorizontalHalfPill = styled.div`
  background-color: ${({ theme }) => theme.colors.green5};
  margin: auto;
  height: 23px;
  width: 100%;
  border-radius: 20px;
  margin: 0;
  ${({ theme }) => theme.media.desktopUp`
    height: 20px;
  `};
  ${props =>
    props.top &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
  ${props =>
    props.bottom &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
    ${props =>
      props.left &&
      css`
        ${props.theme.media.desktopDown`
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      `}
      `}
    ${props =>
      props.right &&
      css`
        ${props.theme.media.desktopDown`
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        `}
      `}
`;

const VerticalGutter = ({ width, height, upper, lower }) => (
  <VerticalGutterWrapper width={width} height={height}>
    <VerticalHalfPill left upper={upper} lower={lower} />
    <VerticalHalfPill right upper={upper} lower={lower} />
  </VerticalGutterWrapper>
);
const HorizontalGutter = ({ width, mobileWidth, marginTop, left, right }) => (
  <HorizontalGutterWrapper
    width={width}
    mobileWidth={mobileWidth}
    marginTop={marginTop}
  >
    <HorizontalHalfPill top left={left} right={right} />
    <HorizontalHalfPill bottom left={left} right={right} />
  </HorizontalGutterWrapper>
);

export { VerticalGutter, HorizontalGutter };
